/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BCCADMINBaseModelsReachabilityReport } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsTypeUsageViewModel } from '../Models';
// @ts-ignore
import type { ConnectionGraphViewModel } from '../Models';
// @ts-ignore
import type { PageConnectionsViewModel } from '../Models';
/**
 * ConnectionsApi - axios parameter creator
 */
export const ConnectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [language] 
         * @param {string} [slug] 
         * @param {boolean} [includeDynamic] 
         * @param {string} [dynamicContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsPageGet: async (id?: string, language?: string, slug?: string, includeDynamic?: boolean, dynamicContentTypes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/connections/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (includeDynamic !== undefined) {
                localVarQueryParameter['includeDynamic'] = includeDynamic;
            }

            if (dynamicContentTypes !== undefined) {
                localVarQueryParameter['dynamicContentTypes'] = dynamicContentTypes;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [language] 
         * @param {boolean} [includeDynamic] 
         * @param {string} [dynamicContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsPageGraphGet: async (language?: string, includeDynamic?: boolean, dynamicContentTypes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/connections/page/graph`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (includeDynamic !== undefined) {
                localVarQueryParameter['includeDynamic'] = includeDynamic;
            }

            if (dynamicContentTypes !== undefined) {
                localVarQueryParameter['dynamicContentTypes'] = dynamicContentTypes;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [language] 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsPageUsageGet: async (id?: string, language?: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/connections/page/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsReachabilityGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/connections/reachability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [key] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsTypeGet: async (key?: string, language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/connections/type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectionsApi - functional programming interface
 */
export const ConnectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConnectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [language] 
         * @param {string} [slug] 
         * @param {boolean} [includeDynamic] 
         * @param {string} [dynamicContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConnectionsPageGet(id?: string, language?: string, slug?: string, includeDynamic?: boolean, dynamicContentTypes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageConnectionsViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConnectionsPageGet(id, language, slug, includeDynamic, dynamicContentTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.apiConnectionsPageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [language] 
         * @param {boolean} [includeDynamic] 
         * @param {string} [dynamicContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConnectionsPageGraphGet(language?: string, includeDynamic?: boolean, dynamicContentTypes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionGraphViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConnectionsPageGraphGet(language, includeDynamic, dynamicContentTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.apiConnectionsPageGraphGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [language] 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConnectionsPageUsageGet(id?: string, language?: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsTypeUsageViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConnectionsPageUsageGet(id, language, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.apiConnectionsPageUsageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConnectionsReachabilityGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsReachabilityReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConnectionsReachabilityGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.apiConnectionsReachabilityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [key] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConnectionsTypeGet(key?: string, language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsTypeUsageViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConnectionsTypeGet(key, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.apiConnectionsTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConnectionsApi - factory interface
 */
export const ConnectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConnectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [language] 
         * @param {string} [slug] 
         * @param {boolean} [includeDynamic] 
         * @param {string} [dynamicContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsPageGet(id?: string, language?: string, slug?: string, includeDynamic?: boolean, dynamicContentTypes?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageConnectionsViewModel> {
            return localVarFp.apiConnectionsPageGet(id, language, slug, includeDynamic, dynamicContentTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [language] 
         * @param {boolean} [includeDynamic] 
         * @param {string} [dynamicContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsPageGraphGet(language?: string, includeDynamic?: boolean, dynamicContentTypes?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectionGraphViewModel> {
            return localVarFp.apiConnectionsPageGraphGet(language, includeDynamic, dynamicContentTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [language] 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsPageUsageGet(id?: string, language?: string, slug?: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsTypeUsageViewModel> {
            return localVarFp.apiConnectionsPageUsageGet(id, language, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsReachabilityGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsReachabilityReport> {
            return localVarFp.apiConnectionsReachabilityGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [key] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConnectionsTypeGet(key?: string, language?: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsTypeUsageViewModel> {
            return localVarFp.apiConnectionsTypeGet(key, language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConnectionsApi - object-oriented interface
 */
export class ConnectionsApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {string} [language] 
     * @param {string} [slug] 
     * @param {boolean} [includeDynamic] 
     * @param {string} [dynamicContentTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConnectionsPageGet(id?: string, language?: string, slug?: string, includeDynamic?: boolean, dynamicContentTypes?: string, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).apiConnectionsPageGet(id, language, slug, includeDynamic, dynamicContentTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [language] 
     * @param {boolean} [includeDynamic] 
     * @param {string} [dynamicContentTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConnectionsPageGraphGet(language?: string, includeDynamic?: boolean, dynamicContentTypes?: string, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).apiConnectionsPageGraphGet(language, includeDynamic, dynamicContentTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [language] 
     * @param {string} [slug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConnectionsPageUsageGet(id?: string, language?: string, slug?: string, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).apiConnectionsPageUsageGet(id, language, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConnectionsReachabilityGet(id?: string, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).apiConnectionsReachabilityGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [key] 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConnectionsTypeGet(key?: string, language?: string, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).apiConnectionsTypeGet(key, language, options).then((request) => request(this.axios, this.basePath));
    }
}

